// extracted by mini-css-extract-plugin
export default {"edge":"ColorEdge_edge__WbBdi","edge--down":"ColorEdge_edge--down__vEEaN"};